import React, { useState } from "react";
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";

// ! from ur friend, if the arabic text is not showing correctly, just change the browser
const PDFFormFiller = () => {
  const [formData, setFormData] = useState({
    violationNumber: "25PV23",
    date: "2023-04-15",
    time: "14:30",
    vehicleType: "Mercedes",
    plateNumber: "1234-ABCD",
    violationType: "expired_parking",
    location: "شارع محمد الخامس",
    fineAmount: "200",
    receiptNumber: "R-12345",
    ownerNameAr: "محمد أحمد",
    ownerDateReference: "AVv 1234",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /**
   * Helper function to set Arabic text in a form field
   * @param {Object} pdfDoc - The PDF document
   * @param {Object} form - The PDF form
   * @param {Object} arabicFont - The embedded Arabic font
   * @param {string} fieldName - The name of the form field
   * @param {string} arabicText - The Arabic text to set
   * @param {number} fontSize - Optional font size (default: 12)
   */
  const setArabicTextField = (
    pdfDoc,
    form,
    arabicFont,
    fieldName,
    arabicText,
    fontSize = 12
  ) => {
    try {
      // Get the form field
      const field = form.getTextField(fieldName);

      if (!field) {
        console.warn(`Field ${fieldName} not found in the form`);
        return;
      }

      // First try with the built-in method
      try {
        // field.setFontSize(fontSize);
        field.setText(arabicText);
        field.updateAppearances(arabicFont);
        console.log(`Set field ${fieldName} with built-in method`);
      } catch (fontError) {
        console.warn(
          `Couldn't set Arabic text with built-in method for field ${fieldName}, using draw method`,
          fontError
        );

        // Get the field's position and size
        const fieldData = field.acroField;
        const fieldRect = fieldData.getRectangle();
        const [x, y, width, height] = [
          fieldRect.x,
          fieldRect.y,
          fieldRect.width,
          fieldRect.height,
        ];

        // Get the page that contains the field
        const pages = pdfDoc.getPages();
        const fieldPage = pages[fieldData.page || 0];

        // Draw text directly on the page at the form field's position
        fieldPage.drawText(arabicText, {
          x: x + 2, // Small offset from left edge
          y: y + 2, // Small offset from bottom edge
          size: fontSize,
          font: arabicFont,
          color: rgb(0, 0, 0),
          // You can add more text options here if needed
        });
        console.log("font size", fontSize);

        // Make the original field invisible
        field.setText("");
      }
    } catch (error) {
      console.error(`Error setting Arabic text for field ${fieldName}:`, error);
    }
  };

  const fillPDFForm = async () => {
    try {
      setIsLoading(true);
      setError(null);

      // Load the PDF template with form fields
      const templateUrl = "/pv_infraction2.pdf";
      const templateBytes = await fetch(templateUrl).then((res) =>
        res.arrayBuffer()
      );

      const pdfDoc = await PDFDocument.load(templateBytes);

      // Register fontkit with PDFDocument
      pdfDoc.registerFontkit(fontkit);

      // Load Arabic font from public folder
      const fontUrl = "/fonts/Segoe-UI.ttf"; //! Dont change this font, it is the only one that works
      const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer());

      console.log("Font bytes loaded:", fontBytes.byteLength, "bytes");

      // Embed the font in the PDF
      const arabicFont = await pdfDoc.embedFont(fontBytes);

      // Get form from the document
      const form = pdfDoc.getForm();

      // Fill in non-Arabic form fields
      const nonArabicFields = {
        violationNumber1: formData.violationNumber,
        violationNumberTwo: formData.violationNumber,
        date1: formData.date,
        date2: formData.date,
        time1: formData.time,
        timeTwo: formData.time,
        OwnerDateReference: "2023-04-15",
        OwnerReference: "AVv 1234",
        VehicleModel: formData.vehicleType,
        VehicleMatricule: formData.plateNumber,
        receiptNumber: formData.receiptNumber,
        fineAmount: formData.fineAmount,
      };

      // Set non-Arabic fields normally
      for (const [fieldName, value] of Object.entries(nonArabicFields)) {
        try {
          const field = form.getTextField(fieldName);
          if (field) {
            field.setText(value);
          }
        } catch (err) {
          console.warn(`Error setting field ${fieldName}:`, err);
        }
      }

      // Get violation type in Arabic
      const violationTypeArabic =
        formData.violationType === "expired_parking"
          ? "تجاوز الوقت المؤدى عنه"
          : formData.violationType === "no_ticket"
          ? "عدم صلاحية بطاقة الإدراك"
          : "عدم أداء واجب الركن";

      // Arabic fields that need special handling
      const arabicFields = {
        violationType: violationTypeArabic,
        location: formData.location,
        OwnerName: "يوسف أحمد",
        // Add any other Arabic text fields here
      };

      console.log(arabicFields.fineAmount);

      // Set Arabic fields using our helper function
      for (const [fieldName, value] of Object.entries(arabicFields)) {
        setArabicTextField(pdfDoc, form, arabicFont, fieldName, value, 12);
      }

      // Save and download the filled PDF
      const pdfBytes = await pdfDoc.save();

      // Create a blob and download
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "violation_notice.pdf";
      link.click();

      setIsLoading(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
      setError(`Error generating PDF: ${error.message}`);
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">
        Violation Notice PDF Form Filler
      </h2>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="mb-4">
          <label className="block mb-1">Violation Number:</label>
          <input
            type="text"
            name="violationNumber"
            value={formData.violationNumber}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">Date:</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">Time:</label>
          <input
            type="time"
            name="time"
            value={formData.time}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">Vehicle Type:</label>
          <input
            type="text"
            name="vehicleType"
            value={formData.vehicleType}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">Plate Number:</label>
          <input
            type="text"
            name="plateNumber"
            value={formData.plateNumber}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">Violation Type:</label>
          <select
            name="violationType"
            value={formData.violationType}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          >
            <option value="expired_parking">تجاوز الوقت المؤدى عنه</option>
            <option value="no_payment">عدم أداء واجب الركن</option>
            <option value="no_ticket">عدم صلاحية بطاقة الإدراك</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block mb-1">Location:</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">Fine Amount:</label>
          <input
            type="text"
            name="fineAmount"
            value={formData.fineAmount}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">Receipt Number:</label>
          <input
            type="text"
            name="receiptNumber"
            value={formData.receiptNumber}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
        </div>
      </div>

      <button
        onClick={fillPDFForm}
        disabled={isLoading}
        className={`${
          isLoading ? "bg-blue-300" : "bg-blue-500 hover:bg-blue-600"
        } text-white px-4 py-2 rounded`}
      >
        {isLoading ? "Generating..." : "Generate PDF"}
      </button>
    </div>
  );
};

export default PDFFormFiller;

/**
   * Fills the PDF form with the provided infraction data.
  
  const fillPDFForm = async () => {
    try {
      const pdfTemplateUrl = "/pv_infraction3.pdf";
      // const fontUrl = "/fonts/Noto.ttf"; // Make sure this font supports Arabic
      const fontUrl = "/fonts/Segoe-UI.ttf"; // Make sure this font supports Arabic
      const outputFileName = "violation_notice_filled.pdf";

      const date = infraction?.datetime_infraction.split(" ")[0]; // Extract date part
      const time = infraction?.datetime_infraction.split(" ")[1]; // Extract time part
      const nonArabicFieldsData = {
        violationNumber1: infraction?.reference,
        violationNumberTwo: infraction?.reference,
        date1: date,
        date2: date,
        time1: time,
        timeTwo: time,
        OwnerDateReference: infraction?.user?.assigned_date, // Example, or use formData
        OwnerReference: infraction?.user?.number, // Example, or use formData
        VehicleModel: infraction?.brand,
        VehicleMatricule: infraction?.matricule,
        fineAmount: infraction?.amount,
      };

      const arabicFieldsData = {
        violationType: infraction?.type_infraction?.name_ar,
        location: infraction?.location_ar,
        OwnerName: " " + infraction?.user?.full_name_ar + " ", // Assuming you have ownerNameAr in formData
        // Add other Arabic fields from formData as needed
      };

      console.log(arabicFieldsData);

      await generateFilledPdf(
        pdfTemplateUrl,
        fontUrl,
        nonArabicFieldsData,
        arabicFieldsData,
        outputFileName,
        9, // Example: Set Arabic font size to 14,
        true
      );
    } catch (error) {
      console.error("Error in fillPDFForm:", error);
      message.error(`Erreur lors de la génération du PDF: ${error.message}`);
    } finally {
    }
  };
   */
